import createPlugin from './createPlugin';
import SpacerHtmlRenderer from './Renderer/SpacerHtmlRenderer';
var plugin = createPlugin({
    Renderer: SpacerHtmlRenderer,
});
export default plugin;
//# sourceMappingURL=index.js.map